import React, { useEffect, useState, Suspense, lazy } from 'react';

// Standard React lazy loading (replaces next/dynamic)
const Plot = lazy(() => import('react-plotly.js'));

export const CryptoTreemap = ({ theme }) => {
    const [plotData, setPlotData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Using your live API URL
                const response = await fetch('/api/py82/api/crypto_coins');
                const coins = await response.json();

                // Format data for Plotly Treemap
                const labels = coins.map(c =>
                    `${c.symbol}<br><span style="font-size:14px">$${c.price?.toFixed(2)}</span><br><span style="font-size:14px">${c.percent_change_24h?.toFixed(2)}%</span>`
                );
                const values = coins.map(c => c.market_cap || 1);
                const colors = coins.map(c => c.percent_change_24h >= 0 ? '#4ade80' : '#ef4444');

                setPlotData([{
                    type: 'treemap',
                    labels,
                    parents: Array(coins.length).fill(""),
                    values,
                    text: labels,
                    hoverinfo: 'skip',
                    textinfo: 'text',
                    textposition: 'middle center',
                    marker: { colors },
                    textfont: {
                        size: 18,
                        color: 'white',
                        family: 'Arial Black, sans-serif',
                    },
                }]);
                setLoading(false);
            } catch (err) {
                console.error("Error loading treemap data:", err);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return <div style={{ color: theme.textSecondary }}>Carregando gráfico...</div>;

    return (
        <div style={{ 
            width: '100%', 
            background: theme.cardBg, 
            borderRadius: '12px', 
            overflow: 'hidden',
            border: `1px solid ${theme.border}` 
        }}>
            {/* Suspense is required when using React.lazy */}
            <Suspense fallback={<div>Loading Plotly...</div>}>
                <Plot
                    data={plotData}
                    layout={{
                        autosize: true,
                        height: 500, // Adjusted height for better fit
                        margin: { t: 0, l: 0, r: 0, b: 0 },
                        paper_bgcolor: 'transparent',
                        plot_bgcolor: 'transparent',
                        font: { color: 'white' }
                    }}
                    config={{ responsive: true, displayModeBar: false }}
                    useResizeHandler
                    style={{ width: '100%', height: '100%' }}
                />
            </Suspense>
        </div>
    );
};